import React from "react";
import { Button } from "ui/components/button";

const QueryError = ({ message = "Something went wrong.", onRetry }) => {
  return (
    <div className="flex flex-col items-center justify-center text-sm text-center text-muted-foreground px-4 py-6 border rounded-md bg-red-50">
      <p className="text-red-500 font-medium">{message}</p>
      {onRetry && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onRetry}
          className="mt-2 text-xs"
        >
          Retry
        </Button>
      )}
    </div>
  );
};

export default QueryError;
